/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedIconBubbleEmail_user$ref = any;
export type PdpRespIconBubbles_user$ref = any;
export type PdpRespIconBubbles_user = {
    readonly " $fragmentRefs": PdpSharedIconBubbleEmail_user$ref;
    readonly " $refType": PdpRespIconBubbles_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubbles_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedIconBubbleEmail_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b7a8dd895310a3ea7fad8ff60cbc97c3';
export default node;
